/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from 'prop-types';
import Heading from '@lmig/dotcom-aspect-components/Utility/Heading';
import css from 'styled-jsx/css';
import { Link } from '@lmig/lmds-react';
import useWindowWidth from '@lmig/dotcom-aspect-comparion-hooks/useWindowWidth';
import Hours from "../Hours";
import OfficeInfoCard from "./OfficeInfoCard";
import AgentQuoteCard from "../Agent/AgentQuoteCard";
import styles from "./OfficeAbout.module.scss";

const OfficeAbout = ({
  office,
  text,
  heading,
  buttonText = 'Start your quote'
}) => {
  const { isMobile } = useWindowWidth({ mobileWidth: 960 });
  const videoUrlDomain = "comparioninsurance.onemob.com/v/";
  const officeProfile = office.videoUrl && !office.videoUrl?.includes(videoUrlDomain);
  const officeVideo = office.videoUrl?.includes(videoUrlDomain);
  const { className: headingClass, styles: headingStyles } = css.resolve`
    @import './global-styles/tokens';
    .lm-Heading {
      color: #1a1446;
      font-size: 1.5rem;
      text-align: left;
      max-width: none;
    }

    @media screen and (min-width: $lm-breakpoint-sm-min) {
      .lm-Heading {
        font-size: 2rem;
      }
    }

    .lm-Heading.hasVideo {
      text-align: center;
      margin-bottom: 0.5em;
    }

    @media screen and (min-width: $lm-breakpoint-md-min) {
      .lm-Heading.hasVideo {
        text-align: left;
      }
    }
  `;

  const { className: officeInfoClass, styles: officeInfoStyles } = css.resolve`
    *{
      width: 100%;
    }
  `;

  return (
    <div className={styles.officeAboutWrapper}>
      <div className={styles.innerWrapper}>
        <AgentQuoteCard
          heading={`${heading} in ${office.address.city}, ${office.address.state.code}`}
          text={text}
          buttonText={buttonText}
          breakpoint="lg"
        />
        {isMobile &&
          <div className={styles.hoursAndLocMobile}>
            {office.dailyHours && <div className={styles.hoursMobile}><Hours dailyHours={office.dailyHours} /></div>}
            <OfficeInfoCard office={office} className={officeInfoClass} />
          </div>
        }
        <Heading type="h3-bold" tag="h2" className={officeVideo ? `${headingClass} hasVideo` : headingClass}>About the {office.address.city}, {office.address.state.code} office</Heading>
        {!!officeProfile &&
          <Link
            onBackground="whites"
            href={office.videoUrl}
            aria-label="Watch our intro video"
            target="_blank"
            rel="noreferrer"
            variant="standalone"
          >
            Watch our intro video
          </Link>
        }
        {!!officeVideo &&
          <iframe className={styles.officeVideo} title="Office video" src={office.videoUrl} allow="fullscreen" />
        }
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: office.description }} itemProp="description" />
      </div>
      {(isMobile !== undefined && !isMobile) &&
        <div className={styles.hoursAndLoc}>
          {office.dailyHours && <Hours dailyHours={office.dailyHours} reservationLink={office?.reservationUrl} type="desktop" />}
          <div className={styles.officeCard}><OfficeInfoCard office={office} /></div>
        </div>
      }
      {headingStyles}
      {officeInfoStyles}
    </div >
  );
};

OfficeAbout.propTypes = {
  office: PropTypes.shape({
    description: PropTypes.string.isRequired
  }).isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  buttonText: PropTypes.string,
};

export default OfficeAbout;
